<template>
	<v-flex
		v-if="show || isSuperUser"
		:class="{ 'py-1': cardStyle !== 0, 'superUser': (!show && isSuperUser) }"
		:sm6="cardStyle === 0"
		:md4="cardStyle === 0"
		:lg3="cardStyle === 0"
		xs12
	>
		<Card
			v-if="cardStyle === 0"
			:show-header="showHeader"
			:image="image"
			:image-text="imageText"
			:url="url"
			:flags="flags"
			:loading="loading"
			@url="$emit('url')"
		>
			<template
				v-if="showHeader"
				slot="header"
			>
				<slot name="card-header" />
				<template slot="checkbox">
					<slot name="checkbox" />
				</template>
			</template>
			<template slot="title">
				<slot name="title" />
				<slot name="card-title" />
			</template>
			<template slot="additional">
				<slot name="additional" />
			</template>
			<template slot="actions">
				<slot name="actions" />
			</template>
		</Card>
		<List
			v-else
			:image="image"
			:image-text="imageText"
			:url="url"
			:flags="flags"
			:loading="loading"
			@url="$emit('url')"
		>
			<template slot="checkbox">
				<slot name="checkbox" />
			</template>
			<template slot="title">
				<slot name="title" />
				<slot name="list-title" />
			</template>
			<template slot="additional">
				<slot name="additional" />
				<slot name="list-additional" />
			</template>
			<template slot="actions">
				<v-spacer />
				<slot name="actions" />
			</template>
		</List>
	</v-flex>
</template>

<script>
import Card from '@/components/Card';
import List from '@/components/List';

export default {
	components: {
		Card,
		List,
	},
	props: {
		image: { default: null, type: String },
		imageText: { default: '', type: String },
		cardType: { default: null, type: Number },
		flags: { default: () => [], type: Array },
		url: { default: null },
		showHeader: { default: false, type: Boolean },
		show: { default: true, type: Boolean },
		loading: { default: false, type: Boolean },
	},
	data() {
		return {
			cardStyle: 0,
		};
	},
	watch: {
		cardType(val) {
			this.cardStyle = val;
		},
	},
	created() {
		if (this.cardType === 0 || this.cardType === 1) {
			this.cardStyle = this.cardType;
		}
		else {
			this.cardStyle = this.$ls.get('cardStyle', 0);
		}
	},
	computed: {
		isSuperUser() {
			return this.$store.get('superUser');
		},
	},
};
</script>

<style>
.semi-hidden {
	opacity: 0.3;
}
</style>
